import login from './login';

export default {
  language: 'sr-Latn-CS',
  country: 'rs',
  name: 'Srpski (latinica)',
  embeddedLocale: login,
};
